var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FE0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 13.8333C4.7826 13.8333 2.16927 11.2199 2.16927 7.99992C2.16927 4.77992 4.7826 2.16658 8.0026 2.16658C11.2226 2.16658 13.8359 4.77992 13.8359 7.99992C13.8359 11.2199 11.2226 13.8333 8.0026 13.8333ZM8.0026 3.33325C5.42427 3.33325 3.33594 5.42158 3.33594 7.99992C3.33594 10.5783 5.42427 12.6666 8.0026 12.6666C10.5809 12.6666 12.6693 10.5783 12.6693 7.99992C12.6693 5.42158 10.5809 3.33325 8.0026 3.33325ZM7.41927 7.99992L7.41927 5.66658L8.58594 5.66658L8.58594 7.99992L10.3359 7.99992L8.0026 10.3333L5.66927 7.99992L7.41927 7.99992Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInActiveIcon);
export default __webpack_public_path__ + "static/media/inActiveIcon.0865fd3367e7368f462e8b282a1d3190.svg";
export { ForwardRef as ReactComponent };